import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useApplication } from '../context/ApplicationContext';

const { FiAlertCircle } = FiIcons;

function FormField({
  label,
  type = 'text',
  value,
  onChange,
  placeholder,
  required = false,
  error,
  icon,
  disabled = false,
  rows = 3,
  min,
  max,
  fieldName,
  ...props
}) {
  const { state } = useApplication();
  const { errors } = state;
  
  const fieldError = error || (fieldName && errors[fieldName]);

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  const inputClasses = `
    w-full px-3 sm:px-4 py-2 sm:py-3 border rounded-lg focus:ring-2 focus:ring-agric-primary focus:border-agric-primary transition-colors duration-200 text-sm sm:text-base
    ${fieldError ? 'border-red-500' : 'border-gray-300'}
    ${disabled ? 'bg-gray-100 cursor-not-allowed' : 'bg-white'}
    ${icon ? 'pl-10 sm:pl-12' : ''}
  `;

  return (
    <div className="space-y-2 w-full max-w-full">
      <label className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <div className="relative w-full">
        {icon && (
          <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
            <SafeIcon icon={icon} className="w-4 h-4 sm:w-5 sm:h-5" />
          </div>
        )}
        {type === 'textarea' ? (
          <textarea
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            required={required}
            disabled={disabled}
            rows={rows}
            className={inputClasses}
            {...props}
          />
        ) : (
          <input
            type={type}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            required={required}
            disabled={disabled}
            min={min}
            max={max}
            className={inputClasses}
            {...props}
          />
        )}
      </div>
      {fieldError && (
        <div className="flex items-center gap-2 text-red-600 text-sm">
          <SafeIcon icon={FiAlertCircle} className="w-4 h-4 flex-shrink-0" />
          <span className="break-words">{fieldError}</span>
        </div>
      )}
    </div>
  );
}

export default FormField;